
    <object data="../../assets/Files/PrivacyPolicy.pdf#toolbar=0" type="application/pdf" width="100%" height="700px"></object>
    